import { reducer as form } from 'redux-form';
import { combineReducers } from 'redux';
import profile from './containers/Callback/reducer';
import shops from './containers/Shops/reducer';
import shop from './containers/ShopDetails/reducer';
import menu from './containers/ShopMenu/reducer';
import customers from './containers/Customers/reducer';
import partners from './containers/DeliveryPartners/reducer';
import managers from './containers/Managers/reducer';
import leads from './containers/Leads/reducer';
import orders from './containers/Orders/reducer';
import extras from './containers/MenuItemExtras/reducer';
import dashboard from './containers/Dashboard/reducer';

export const reducersList = {
  form,
  shops,
  shop,
  menu,
  customers,
  partners,
  managers,
  profile,
  leads,
  orders,
  extras,
  dashboard,
};

const reducers = combineReducers(reducersList);

export default reducers;